import PlayerControls from "./playerControls";

export default PlayerControls;
